import { render } from "./RatingItem.vue?vue&type=template&id=9c511c9a&ts=true"
import script from "./RatingItem.vue?vue&type=script&lang=ts"
export * from "./RatingItem.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__